module.exports = __webpack_public_path__ + "zvetseni-prsou_50_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zvetseni-prsou_50_before_tn.jpg
// module id = 1814
// module chunks = 0